import { gettext } from '@eventbrite/i18n';
import { Badge } from '@eventbrite/marmalade';
import React from 'react';
import { CancelledIcon, FewTicketsIcon, WarningIcon } from '../_shared/Icons';

import styles from './Badges.module.scss';

export enum BadgeType {
    soldOut = 'soldOut',
    fewTicketsLeft = 'fewTicketsLeft',
    cancelled = 'cancelled',
    postponed = 'postponed',
    salesEnded = 'salesEnded',
    eventEnded = 'eventEnded',
}

export interface BadgeFactoryProps {
    type: BadgeType;
    className?: string;
}

const badgeComponents = {
    soldOut: () => (
        <Badge className={styles.badge} variant="info" icon={<CancelledIcon />}>
            <span className={styles.badgeText}>{gettext('Sold Out')}</span>
        </Badge>
    ),
    cancelled: () => (
        <Badge className={styles.badge} variant="info" icon={<CancelledIcon />}>
            <span className={styles.badgeText}>{gettext('Cancelled')}</span>
        </Badge>
    ),
    postponed: () => (
        <Badge
            className={styles.badge}
            variant="warning"
            icon={<WarningIcon />}
        >
            <span className={styles.badgeText}>{gettext('Postponed')}</span>
        </Badge>
    ),
    salesEnded: () => (
        <Badge
            className={styles.badge}
            variant="warning"
            icon={<WarningIcon />}
        >
            <span className={styles.badgeText}>{gettext('Sales Ended')}</span>
        </Badge>
    ),
    eventEnded: () => (
        <Badge
            className={styles.badge}
            variant="warning"
            icon={<CancelledIcon />}
        >
            <span className={styles.badgeText}>{gettext('Event Ended')}</span>
        </Badge>
    ),
    // urgency signals
    fewTicketsLeft: () => (
        <Badge
            className={styles.badge}
            variant="danger"
            icon={<FewTicketsIcon />}
        >
            <span className={styles.badgeText}>
                {gettext('Few Tickets Left')}
            </span>
        </Badge>
    ),
} as const;

export const BadgeFactory: React.FC<BadgeFactoryProps> = ({ type }) => {
    const BadgeComponent = badgeComponents[type];

    if (!BadgeComponent) {
        console.warn(`Badge type "${type}" not found`);
        return null;
    }

    return <BadgeComponent />;
};
